import React, { FC } from 'react'
import styled from 'styled-components'
import { Box, SupportMessage, Text } from '@mrshmllw/smores-react'

import { useEventTracking } from 'utils'

export const RegPlateError: FC = () => {
  const track = useEventTracking()
  return (
    <Wrapper maxWidth="418px">
      <SupportMessage
        type="warning"
        title="Check your registration plate"
        description={
          <Box flex direction="column">
            <Text>We can’t find that car for some reason. Please check that:</Text>
            <ErrorList>
              <li>all characters are in the right order</li>
              <li>your 0 (zeros) and O (letters) are correct</li>
              <li>it’s a UK registration plate (we can’t cover other plates yet)</li>
            </ErrorList>
            <Text>
              If you keep getting this message,{' '}
              <a
                href="https://www.marshmallow.com/help"
                target="_blank"
                rel="noreferrer"
                onClick={() => track('Clicked regplate get in touch')}
              >
                please get in touch
              </a>
              .
            </Text>
          </Box>
        }
      />
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  p > a {
    cursor: pointer;
    text-decoration: underline;
  }
`

const ErrorList = styled.ul`
  list-style: disc;
  padding-bottom: 16px;
  padding-left: 20px;
  margin-top: 16px;
`
